import {APIError} from '../core/errors';
import httpClient from '../services/http.service';
import {BASE_URL, DEFAULT_HEADERS} from './api-constants';

const _api_base_url = `${BASE_URL}/missingsize/product-search`;
//  'https://run.mocky.io/v3/fe53d798-9cb7-42c7-90ba-1765f6f50bd4';
//'http://14.142.50.123:7001/BuddyLMREnrolementWS/LSBEnrolement/LSBuddyEnrolDetails';
//TODO: - write the API calls here

interface user {
  result: boolean;
  resultCode: string;
  message: string;
  itemCode: string;
  eanNumber: string;
  size: string;
  color: string;
  base_product: string;
  base_product_1: string;
}

interface userPayload {
  payload: {
    eanNumber: string;
  };
  accessToken: string;
}
// test user fetch.
// TODO: remove later
export const productearch = async (parameters: userPayload): Promise<user> => {
  //todo
  // dob has to be non mandatory

  try {
    let url = _api_base_url;
    url += `?code=${parameters.payload.eanNumber}`;
    const response = await httpClient.get(url, {
      headers: {
        ...DEFAULT_HEADERS,
        Authorization: `Bearer ${parameters.accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
